import script from "./UnsupportOpenPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnsupportOpenPage.vue?vue&type=script&lang=ts&setup=true"

import "./UnsupportOpenPage.vue?vue&type=style&index=0&id=086995ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086995ec"]])

export default __exports__